import React from "react";
import styles from "./FinishedEventItem.module.scss";
import { JikeiBadgeSVG } from "../../assets/img/JikeiBadgeSVG";
import { SonicTermData } from "../../common/classes/SonicTerm";
import { timestampToTime } from "../../utils/GeneralUtils";
import SonicLink from "../../common/routing/SonicLink";

type Props = {
  id: string;
  name: string;
  img: string;
  start_date: number;
  end_date: number;
  type: SonicTermData;
  isJikei: boolean;
};
const FinishedEventItem: React.FC<Props> = ({
  id,
  name,
  img,
  start_date,
  end_date,
  type,
  isJikei,
}) => {
  return (
    <SonicLink to={`/event/${id}`} className={styles["finished-item"]}>
      <div className={styles["finished-item__image"]}>
        <img src={img} />
        {isJikei ? (
          <div className={styles["finished-item__badge"]}>
            <JikeiBadgeSVG />
          </div>
        ) : null}
      </div>
      <div className={styles["finished-item__info"]}>
        <div className={styles["finished-item__title"]}>{name}</div>
        <div>{`${timestampToTime(
          start_date,
          false,
          false,
          "/"
        )} - ${timestampToTime(end_date, false, false, "/")}`}</div>
        <div className={styles["finished-item__type"]}>{type.name}</div>
      </div>
    </SonicLink>
  );
};

export default FinishedEventItem;
